import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../assets/open.png'


const _hoisted_1 = { class: "flex justify-between" }
const _hoisted_2 = { class: "flex space-x-4" }
const _hoisted_3 = { class: "flex flex-col justify-center space-y-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { style: {"color":"brown"} }, "sender", -1)
const _hoisted_5 = { class: "black-title" }
const _hoisted_6 = { class: "flex flex-col items-end space-y-1" }
const _hoisted_7 = { class: "flex space-x-2" }
const _hoisted_8 = { class: "font-semibold" }
const _hoisted_9 = { class: "blue-title" }
const _hoisted_10 = { class: "flex space-x-2" }
const _hoisted_11 = { class: "assets-time" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_card = _resolveComponent("a-card")!

  return (_openBlock(), _createBlock(_component_a_card, {
    loading: _ctx.loading,
    class: "assets-card"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _hoisted_4,
            _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.shortenAddress(_ctx.address)), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.title), 1)
          ]),
          _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.shortenAddress(_ctx.param2).length == 0 ? _ctx.param2 : _ctx.shortenAddress(_ctx.param2)), 1),
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.endDayFormat(_ctx.day)), 1),
            _createElementVNode("img", {
              src: _imports_0,
              class: "h-3 w-3 mt-1 cursor-pointer",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.openUrl(_ctx.hash,_ctx.logIndex)))
            })
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["loading"]))
}